var map = {
	"./Magnum_Opus_Stage_1_bw.webp": 5257,
	"./Magnum_Opus_Stage_2_bw.webp": 8370,
	"./Magnum_Opus_Stage_3_bw.webp": 4319,
	"./Magnum_Opus_Stage_4_bw.webp": 3832,
	"./Magnum_Opus_Stage_5_bw.webp": 8861,
	"./Magnum_Opus_Stage_6_bw.webp": 6662,
	"./Magnum_Opus_Stage_7_bw.webp": 6547,
	"./Magnum_Opus_Stage_8_bw.webp": 3212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1687;